import React, { ReactElement } from 'react';

import styles from './SocialIcons.module.scss';

// Glyphs are the hand-drawn set from the Pulse.Web footer design. The tile takes its fill from
// the stylesheet and the cut-out logo uses currentColor, so both follow the link's hover state.
const TILE_22 =
  'M20.9971 17.1116C20.9586 19.083 19.3151 20.9035 17.124 20.9799C16.0288 20.9035 5.8257 20.9799 4.85951 21C3.50376 20.8591 0.972227 19.7046 1.0415 17.0417C1.0042 15.9027 0.991172 6.50542 1.00597 4.88682C1.32745 2.5643 2.57131 0.921429 4.88674 1.02622C6.06844 1.00313 16.0092 0.984776 17.124 1.01852C19.0931 1.05404 20.781 2.4305 20.9971 4.88682C21.0007 6.45628 21.0013 15.7049 20.9971 17.1116Z';

const TILE_20 =
  'M19.9971 16.1116C19.9586 18.083 18.3151 19.9035 16.124 19.9799C15.0288 19.9035 4.8257 19.9799 3.85951 20C2.50376 19.8591 -0.0277727 18.7046 0.0414951 16.0417C0.00419706 14.9027 -0.00882764 5.50542 0.00597316 3.88682C0.327446 1.5643 1.57131 -0.0785709 3.88674 0.0262178C5.06844 0.00312875 15.0092 -0.0152241 16.124 0.0185214C18.0931 0.054043 19.781 1.4305 19.9971 3.88682C20.0007 5.45628 20.0013 14.7049 19.9971 16.1116Z';

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <path className={styles.tile} d={TILE_20} />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66521 6.99663C4.77828 5.68054 5.73678 4.61192 7.2139 4.50595C7.85389 4.50181 12.1165 4.5024 13.02 4.5024C14.3337 4.54858 15.4568 5.7356 15.4923 7.01083C15.5177 7.89178 15.4846 12.02 15.4822 12.9507C15.4568 13.9009 14.4988 15.1341 13.1555 15.3283C12.3965 15.3455 7.31632 15.3798 6.91374 15.3212C5.10745 14.86 4.72441 13.5717 4.66935 12.8867C4.61488 12.5303 4.65751 7.76331 4.6658 6.99603L4.66521 6.99663ZM3.47404 13.0348C3.54627 14.8872 5.21639 16.4762 7.15943 16.5301L13.2195 16.5189C15.1282 16.4212 16.6633 14.6101 16.6686 12.9152L16.671 6.9611C16.6337 4.99556 14.8813 3.40596 13.3349 3.34616L7.01498 3.32958C5.38097 3.32426 3.62856 4.8588 3.49594 6.66627C3.45805 7.76686 3.47167 11.9282 3.47404 13.0353V13.0348ZM7.87698 9.92896C7.89474 8.69931 8.86804 7.72246 10.1184 7.73903C11.3208 7.75502 12.2923 8.77627 12.2687 9.98165C12.2456 11.1574 11.2989 12.1064 10.1166 12.1301C8.89172 12.1544 7.85981 11.1568 7.87698 9.92896ZM6.68699 9.92718C6.68522 11.8122 8.22213 13.3473 10.1178 13.3142C11.9667 13.2822 13.4492 11.8134 13.4551 9.95264C13.461 8.11024 11.9519 6.58457 10.1202 6.55142C8.22805 6.55734 6.69469 8.06406 6.68699 9.92659V9.92718ZM12.8021 6.4484C12.824 6.87052 13.1579 7.21272 13.5901 7.20916C14.0317 7.20561 14.3745 6.86934 14.3846 6.44485C14.3946 6.00497 14.0453 5.62074 13.5954 5.62666C13.1567 5.63436 12.779 6.00083 12.8021 6.4484Z"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
    <path className={styles.tile} d={TILE_22} />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9995 6.97744C13.0086 6.94741 12.4676 7.05561 12.204 7.36209C11.8625 7.81983 11.9559 8.99589 11.9618 9.56579C12.4761 9.56635 13.6052 9.55162 13.9136 9.55219C13.7903 10.3991 13.6286 11.5027 13.602 11.6879C13.0161 11.6902 12.4697 11.6856 11.9623 11.6879C11.965 12.7456 11.9714 16.3955 11.9623 17C11.8065 17 9.83975 16.9989 9.76879 17C9.76879 16.821 9.78213 11.9094 9.78266 11.6879C9.34406 11.6879 8.48075 11.6879 8 11.6879C8.00213 11.4132 8 10.3034 8 9.53576C8.18568 9.53463 9.69782 9.53576 9.78319 9.53576C9.78266 8.22318 9.5815 6.62904 10.6038 5.67901C11.2873 5.04396 12.4062 4.81793 13.9968 5.15726C13.9968 5.66995 14 6.59901 14 6.97744H13.9995Z"
    />
  </svg>
);

const YouTubeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
    <path className={styles.tile} d={TILE_20} transform="translate(1 1)" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      transform="translate(4 6)"
      d="M1.94134 0H12.0587C13.1266 0 14 0.851377 14 1.89113V8.10887C14 9.14863 13.126 10 12.0587 10H1.94134C0.873352 10 0 9.14863 0 8.10887V1.89113C0 0.851377 0.873352 0 1.94134 0Z"
    />
    <path
      className={styles.tile}
      fillRule="evenodd"
      clipRule="evenodd"
      transform="translate(9.398 9.134)"
      d="M0 3.31742V0.486323C0.0118406 0.193267 0.16044 -0.104525 0.518027 0.0357867L3.24078 1.34181C3.73513 1.57092 3.80913 2.05521 3.25084 2.35714L0.623409 3.63889C0.161032 3.84196 0.0118412 3.58146 0.000592609 3.31801L0 3.31742Z"
    />
  </svg>
);

const TikTokIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
    <path className={styles.tile} d={TILE_22} />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4488 12.9608C11.463 14.8156 9.76798 15.6137 8.61293 14.8304C6.91972 13.6825 7.8942 11.0983 9.97697 11.3801V9.4323C7.65384 9.41513 5.64093 10.6164 5.6433 13.187C5.64448 14.5137 6.20277 15.5042 7.16068 16.3614C8.58806 17.4537 10.5684 17.3708 11.9313 16.3419C12.9839 15.5474 13.4883 14.3562 13.4824 13.0472C13.4806 12.6233 13.4439 9.41572 13.4919 8.84086C13.8938 9.03268 15.0223 10.0249 16.3514 9.81535C16.3514 9.74549 16.3514 7.94985 16.352 7.72311C14.2905 7.70653 13.6357 6.71665 13.4131 4.84761H11.463L11.4488 12.9608Z"
    />
  </svg>
);

// Not in the design yet (A2P-4472 lists it), so it reuses the design's tile with a matching glyph.
const LinkedInIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
    <path className={styles.tile} d={TILE_22} />
    <g fill="currentColor">
      <circle cx="7.05" cy="6.9" r="1.2" />
      <rect x="6" y="9.3" width="2.1" height="6.7" />
      <path d="M9.6 9.3h2v.95c.35-.62 1.1-1.1 2.1-1.1 1.95 0 2.3 1.25 2.3 2.9V16h-2.05v-3.55c0-.85-.05-1.6-1-1.6s-1.3.7-1.3 1.55V16H9.6z" />
    </g>
  </svg>
);

type SocialLink = {
  name: string;
  href: string;
  Icon: () => ReactElement;
};

export const SOCIAL_LINKS: Array<SocialLink> = [
  { name: 'Instagram', href: 'https://www.instagram.com/__medrecruit/', Icon: InstagramIcon },
  { name: 'Facebook', href: 'https://www.facebook.com/Medrecruit/', Icon: FacebookIcon },
  { name: 'YouTube', href: 'https://www.youtube.com/user/medrecruit', Icon: YouTubeIcon },
  { name: 'TikTok', href: 'https://www.tiktok.com/@medrecruit', Icon: TikTokIcon },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/medrecruit-limited/',
    Icon: LinkedInIcon,
  },
];

const SocialIcons = () => (
  <ul className={styles.socialIcons} aria-label="Medrecruit on social media">
    {SOCIAL_LINKS.map(({ name, href, Icon }) => (
      <li key={name}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Medrecruit on ${name} (opens in a new tab)`}
          className={styles.socialIconLink}
        >
          <Icon />
        </a>
      </li>
    ))}
  </ul>
);

export default SocialIcons;
